import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ChevronsDown } from "lucide-react";

export const ScrollHint = () => {
  const loc = useLocation();
  const [show, setShow] = useState(false);
  useEffect(() => {
    const check = () => setShow(document.documentElement.scrollHeight > window.innerHeight + 200);
    const t = setTimeout(check, 600);
    window.addEventListener("resize", check);
    return () => { clearTimeout(t); window.removeEventListener("resize", check); };
  }, [loc.pathname]);
  if (!show) return <div className="h-2" />;
  return (
    <div className="mx-auto flex max-w-7xl justify-center px-4 pt-3 print:hidden" data-testid="scroll-hint-bar">
      <button onClick={() => window.scrollBy({ top: window.innerHeight * 0.8, behavior: "smooth" })} data-testid="scroll-hint"
        className="flex items-center gap-2 whitespace-nowrap rounded-full border border-primary/40 bg-primary/10 px-4 py-2 font-mono text-[11px] uppercase tracking-wide sm:px-5 sm:tracking-widest text-primary transition-colors hover:bg-primary hover:text-primary-foreground sm:text-sm">
        <ChevronsDown size={18} className="animate-bounce" /> Scroll to bottom of page
      </button>
    </div>
  );
};
